import { ActionReducerMap } from '@ngrx/store';
import { orderRequestFetchReducer } from './order-request.reducer';
import { OrderRequestState } from '../order-requet.state';

export const customReducers: ActionReducerMap<OrderRequestState> = {
    fetch: orderRequestFetchReducer,
};